const NAMESPACE = "userFeedbackDialog";

const KEYS = {
    contentTextAreaLabelVoluntary: "contentTextAreaLabelVoluntary",
    contentTextAreaLabelInvoluntary: "contentTextAreaLabelInvoluntary",
    remainingCharsLabel: "remainingCharsLabel"
};

const MESSAGES = {
    [KEYS.contentTextAreaLabelVoluntary]: {
        value: "What feedback do you have for us?",
        comment:
            "Label for the text area where the user can enter the details of their feedback if they deliberately initiated giving feedback"
    },
    [KEYS.contentTextAreaLabelInvoluntary]: {
        value: "Is there anything we can do to improve this page?",
        comment:
            "Label for the text area where the user can enter the details of their feedback if we've showed them this dialog without their deliberate action"
    },
    [KEYS.remainingCharsLabel]: {
        value: "Remaining characters:",
        comment: "Label indicating the number of remaining characters that the user can enter for their feedback"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
